import { format } from 'date-fns';

/**
 * Format date for viewing in the app
 * @param {Date} date Date object
 * @returns {string} Formatted date string
 */
export const viewDateFormat = (date) => {
    return date ? format(new Date(date), 'dd MMMM yyyy') : '';
};
export const orderDateViewFormat = (date) => {
    return date ? format(new Date(date), 'dd-MM-yyyy') : '';
};

/**
 * Format date for saving to the database
 * @param {Date} date Date object
 * @returns {string} Formatted date string
 */
export const saveDateFormat = (date) => {
    return date ? format(new Date(date), 'yyyy-MM-dd') : '';
};

export const dateToTimeFormat = (date) => {
    return date ? format(new Date(date), 'hh:mm a') : '';
};

export const getUserFirstAndLastLetter = (firstName, lastName) => {
    const firstLetter = firstName ? firstName.charAt(0).toUpperCase() : '';
    const lastLetter = lastName ? lastName.charAt(0).toUpperCase() : '';
    return [firstLetter, lastLetter];
};

export const capitalizeFirstLetter = (str) => {
    if (typeof str !== 'string') return '';
    return str
        ?.split(' ')
        .map((word) => word?.charAt(0).toUpperCase() + word?.slice(1)?.toLowerCase())
        ?.join(' ');
};
export const assetPath = (url) => `${process.env.NEXT_PUBLIC_CDN_URL}/web-app/assets/${url}`;
export const getCdnUrl = (imageUrl) => {
    if (
        imageUrl?.startsWith(`https://firebasestorage.googleapis.com/v0/b/${process.env.NEXT_PUBLIC_STORAGE_BUCKET}/o/`)
    ) {
        return imageUrl.replace(
            `https://firebasestorage.googleapis.com/v0/b/${process.env.NEXT_PUBLIC_STORAGE_BUCKET}/o/`,
            process.env.NEXT_PUBLIC_CDN_URL + '/'
        );
    }
    return imageUrl;
};

export const priceFormat = (price, precision = 2) => {
    if (price && !Number.isNaN(price)) {
        return Number(price).toFixed(precision);
    }
    return price;
};

/**
 * Calculate discount percentage between markup price and selling price
 * @param {number} markupPrice - The original/markup price
 * @param {number} sellingPrice - The current selling price
 * @returns {number} Discount percentage rounded to nearest integer
 */
export const calculateDiscountPercentage = (markupPrice, sellingPrice) => {
    if (!markupPrice || !sellingPrice || markupPrice <= sellingPrice) {
        return 0;
    }
    const discount = ((markupPrice - sellingPrice) / markupPrice) * 100;
    const roundedDiscount = Math.round(discount);

    // Cap maximum discount at 99%
    return Math.min(roundedDiscount, 99);
};
